import { createContext } from '@10d/tend-ui-factories';

const [FieldProvider, useFieldProvider] = createContext('FieldProvider');

export { FieldProvider, useFieldProvider };
